class FormCheckTarget {
    constructor(el) {
        this.el = el;
        let getTarget = document.getElementById(this.el.dataset.formCheckEnableTarget);
        if(getTarget) {
            this.target = getTarget;
            this.el.onclick = () => {
                if(this.el.checked) {
                    this.target.removeAttribute('disabled');
                } else {
                    this.target.setAttribute('disabled','disabled');
                }
            }
        }
    }
}

export function createFrom(wrappers) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new FormCheckTarget(node);
        }
    });
}